module.exports = __webpack_public_path__ + "img/cannyhr-logo.7375d7d3.png";